import React from 'react';

const LoadingState = ({ message }) => (
  <div className="flex items-center justify-center h-72 md:h-80 lg:h-96">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500 mx-auto mb-4"></div>
      <p className="text-sm md:text-base text-gray-600">{message}</p>
    </div>
  </div>
);

export default LoadingState;
